import React, { useState } from "react";
import Icon from "components/Icon";
import "./index.css";
import localforage from "localforage";
const BASE_URL = `https://apichat.maybetech.com/api/v1`;

const Modal = ({ isOpen, onClose, children }) => {
  return (
    <>
      {isOpen && (
        <div className="modal-overlay" onClick={onClose}>
          <div
            className="delete-modal-content text-center"
            onClick={(e) => e.stopPropagation()}
          >
            {children}
          </div>
        </div>
      )}
    </>
  );
};

// Example usage in another component
const DeleteChatModal = ({ modelType, isModalOpen, yesDelete, justCloseIt, contact, type }) => {
  // ...existing code...
  const [confirmText, setConfirmText] = useState("");
  const canDelete = confirmText === "DELETE";
  return (
    <div>
      <Modal isOpen={isModalOpen}>
        <div className="scrollable-modal-content-new" >
          <span style={{ position: 'absolute', top: 20, right: 20, cursor: 'pointer', color: 'black' }} onClick={justCloseIt}>
            <Icon id="close" size={20} />
          </span>
          <b style={{ fontSize: 22, marginBottom: 12, display: 'block', textAlign: 'center' }}>
            Delete {modelType}
          </b>

          {/* Warning box UI only, no logic change */}
          <div style={{
            background: '#ffe5e5',
            border: '1px solid #f5c2c7',
            color: 'black',
            padding: '16px',
            borderRadius: '6px',
            marginBottom: '18px',
            display: 'flex',
            gap: 10
          }}>
            <span style={{ fontWeight: 'bold', fontSize: 18 }}>⚠️</span>
            <span style={{ fontSize: 15 }}>
              <b>{`You're about to delete this ${modelType.toLowerCase()}. This action is permanent and cannot be undone.`}</b>
            </span>
          </div>

          {/* Confirmation input UI only, no logic change */}
          <div style={{ marginBottom: 16 }}>
            <label style={{ textAlign: 'left', fontWeight: 500, fontSize: 14, display: 'block', marginBottom: 6 }}>Type <b>DELETE</b> to proceed</label>
            <input
              type="text"
              value={confirmText}
              onChange={e => setConfirmText(e.target.value)}
              placeholder="Type DELETE to proceed"
              style={{
                width: '100%',
                padding: '10px',
                borderRadius: '4px',
                border: '1px solid #ccc',
                fontSize: '15px',
                marginBottom: 0
              }}
            />
          </div>

          <div className="delete_modalBtnGroup">
            <button
              type="submit"
              className="delete_agreeBtn"
              onClick={canDelete ? yesDelete : undefined}
              disabled={!canDelete}
              style={{
                background: canDelete ? '#d32f2f' : '#f5c2c7',
                color: canDelete ? 'white' : '#b71c1c',
                cursor: canDelete ? 'pointer' : 'not-allowed',
                opacity: canDelete ? 1 : 0.7
              }}
            >
              Delete {modelType}
            </button>


          </div>
        </div>
      </Modal>
    </div>
  );
};

export default DeleteChatModal;
